import { render, staticRenderFns } from "./InsuranceCard.vue?vue&type=template&id=a35db232&scoped=true&"
import script from "./InsuranceCard.vue?vue&type=script&lang=ts&"
export * from "./InsuranceCard.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceCard.vue?vue&type=style&index=0&id=a35db232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35db232",
  null
  
)

export default component.exports